var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowRightIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Frame"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M27.4405 25.0015L17.1284 35.3133L20.0747 38.2596L33.333 25.0015L20.0747 11.7432L17.1284 14.6894L27.4405 25.0015Z",
    fill: "#BEC9C5"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowRightIcon);
export default __webpack_public_path__ + "static/media/Arrow_right__icon.c298efe2eaa08b2ddc9b0b952cddc495.svg";
export { ForwardRef as ReactComponent };